import { getSmsSysSettingItemType } from "@/api/setting";

const dict = {
  state: {},
  mutations: {
    SET_STATE: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
  },
  actions: {
    GetDictByType({ commit, state }, type) {
      if (state[type] && state[type].length > 0) {
        return state[type];
      } else {
        return new Promise((resolve, reject) => {
          getSmsSysSettingItemType(type).then(response => {
            commit('SET_STATE', { [type]: response.data })
            resolve(state[type])
          }).catch(error => {
            reject(error)
          })
        })
      }
    },
  },
}
export default dict


// WEBPACK FOOTER //
// ./src/store/modules/dict.js